import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'

export const Wrapper = styled(Box)(`
    width: 100%;
`)

export const ContentWrapper = styled(Box)(`
    width: 100%;
    padding:0px 0px 10px 0;
`)

export const ReportSandboxWrap = styled(Box)(`
    display: flex;
    flex-direction: column;
    gap: 8px;
    & .Information {
        flex: 1;
        overflow: auto;
    }
    @media (max-width: 980px) {
        flex-direction: column;
    }
`)

export const LeftGrid = styled(Box)(`
    display: flex;
    @media (max-width: 980px) {
       width: 100%;
    }
`)

export const RightGrid = styled(Box)(`
    overflow-y: auto; 
    width: 100%;
    display: flex;
    @media (max-width: 980px) {
       margin-top: 30px;
    }
    & .noDataFound{
        padding: 0;
        margin: auto;
        margin-top : calc(100vh - 620px);
    }
`)

export const FiltersWrap = styled(Box)(`
    width: 100%;
    padding: 8px;
    background: #F6F6F5;
    position: sticky;
    top: 10px;
    & .formLabel {
        padding-top: 0px;
        padding-bottom: 0px;
        font-size: 13px;
        font-weight: 400; 
    }
`)

export const FilterItemWrap = styled(Box)(`
    width: 18%;
    &.defaultItem {
        & .selectPlaceholder {
            margin-left: 0;
            font-size: 14px;
        }
        & .MuiBox-root .MuiInputBase-root {
            box-shadow: none;
            padding-right: 0px;
            & img {
                right: 0;
            }
        }
        & .MuiSelect-standard {
        font-size: 16px;
        font-weight: 400;
        }
        & .selectWrap .MuiSelect-select {
         padding: 0px;
         padding-right : 20px;
        }
        & .formLabel{
            display: block;
            color: #545454;
        }
    }
`)

export const HeadingRow = styled(Box)(`
    display: flex;
    align-items: center;
    // border: 1px solid red;
    flex-wrap: wrap;
    padding-top:15px;
    & img {
        margin: 0 5px;
    }
`)

export const StyledTypography = styled(Typography)(`
    margin: 0 5px;
`)

export const FilterByHeading = styled(Typography)(`
    font-weight: 600; // 500;
    font-size: 14px;
    margin-bottom: 20px;
    border: 1px solid green;
`)

export const InfoToolTipWrap = styled(Box)(`
    margin-top: -2px;
    margin-left: 0px;
    svg {
        width: 18px;
        height: 18px;
        fill: #545454;
    }
`)

export const LegendWrapper = styled(Box)(`
    padding-top:20px;
    & > div {justify-content:end;}
`)

export const AdvanceWrapper = styled(Box)(`
  display : flex;
  justify-content : space-between;  
  position : relative;
`)

export const VerbatimImageVideoWrapper = styled(Box)(`
  & > .MuiBox-root {
    margin-top : -5px;
  }
`)

// Chip css START
export const DisplayChipsWrapper = styled(Box)(`
    display: flex;
    align-items: center;
    gap: 4px; 
    flex-wrap: wrap;
    max-width: calc(100% - 140px); 
    margin-left: 25px;
`)

export const AdvanceSearchWrapper = styled(Box)(`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  & label{
      font-size: 14px;
      font-weight: 400; // 300;
  }
`)

export const ChipsItem = styled(Box)(`
  font-size: 12px;
  font-weight: 400; // 300;
  color: #454545;
  background-color: #F2F8FF;
  padding: 2px 8px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  & span{
      margin-left: 8px;
      cursor: pointer;
      color: #095BBD;
  }
  
  & .text-truncate {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: 170px;
    color: #454545;
    margin-left: 0;
    cursor: auto;
  }
`)
// Chip Css END

export const FilterChip = styled(Box)(`
  position: absolute;
  top: 2px;
`)
